<template>
  <div class="form__field">
    <label v-if="label" class="form__label" :for="id">
      <span v-html="label" />
      <info-tooltip v-if="info" :text="info" />
    </label>
    <div class="form__field-container">
      <slot />
    </div>
  </div>
</template>

<script>
import infoTooltip from "@/shared/info-tooltip"

export default {
  components: {
    infoTooltip
  },
  name: "Field",
  props: {
    id: { type: String, default: null },
    label: { type: String, default: null },
    info: { type: String, default: null }
  }
}
</script>
